import React from "react";
import ReactDOM from "react-dom";

class CartShare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      savingInProgress: false,
      completedSave: false,
      name: "",
    };
    this.onClickShare = this.onClickShare.bind(this);
    this.getShopifyCart = this.getShopifyCart.bind(this);
    this.saveCart = this.saveCart.bind(this);
    this.saveSuccess = this.saveSuccess.bind(this);
    this.saveFail = this.saveFail.bind(this);
    this.setName = this.setName.bind(this);
  }

  onClickShare() {
    this.setState({ savingInProgress: true });
    this.getShopifyCart();
  }

  getShopifyCart() {
    $.ajax({
      method: "GET",
      url: window.Shopify.routes.root + "cart.json",
    }).done(
      function (data) {
        let cart_id = data.token.slice(-10);

        let draft_order_items = data.items.map((item) => {
          return {
            productable_id: item.properties["_ProductableID"],
            productable_type: item.properties["_ProductableType"],
            country: window.App.currentCountry,
          };
        });

        console.log(draft_order_items);

        this.saveCart(cart_id, draft_order_items);
      }.bind(this)
    );
  }

  saveCart(cart_id, draft_order_items) {
    let draft_order = {
      draft_order_items_attributes: draft_order_items,
      notes: this.state.name,
    };

    $.ajax({
      method: "POST",
      url: this.props.share_path,
      data: { draft_order: draft_order },
    })
      .done(this.saveSuccess)
      .fail(this.saveFail);
  }

  saveSuccess(data) {
    console.log("DONE!!!");
    this.setState({ savingInProgress: false, completedSave: true });
  }

  saveFail(data) {
    console.log(data);
    this.setState({ savingInProgress: false });
    console.log(data.responseJSON.error);
    this.setState({ error: data.responseJSON.error });
  }

  setName(e) {
    this.setState({ name: e.target.value });
  }

  render() {
    return (
      <div className="f">
        <div className="form-group text-left mb-4">
          <label className="control-label" htmlFor="width">
            Enter your name
          </label>
          <input
            className="form-control border-solid border border-stone-200"
            onChange={this.setName}
            value={this.state.name}
            ref="name"
            id="name"
          />
        </div>
        <button
          type="button"
          disabled={this.state.savingInProgress || this.state.completedSave}
          onClick={this.onClickShare}
          className="btn btn-primary disabled:bg-stone-400 disabled:border-stone-400 disabled:text-white disabled:cursor-not-allowed"
        >
          {this.state.savingInProgress && (
            <i className="fa-solid fa-spinner fa-spin mr-2"></i>
          )}
          {this.state.completedSave && (
            <i className="fa-solid fa-check mr-2"></i>
          )}
          {!this.state.completedSave
            ? "Share my cart"
            : "Shared! We'll be in touch soon."}
        </button>
      </div>
    );
  }
}

export default CartShare;
